import React from 'react'
import PropTypes from 'prop-types'

export class DeliveryHourEditRowAdder extends React.Component {

  constructor(props){
    super(props)
    this.onDeliveryHourAdderClicked = this.onDeliveryHourAdderClicked.bind(this)
  }

  onDeliveryHourAdderClicked(){
    let newDeliveryTimeSlots = this.props.row.poolTimes
    newDeliveryTimeSlots.push({ startTime: '', endTime: '' })
    this.props.onChange({
      ...this.props.row,
      poolTimes: newDeliveryTimeSlots
    },
    this.props.dayName)
  }

  render() {
    return <button className="editRowButton" name="deliveryHourAdder" title="add delivery hours" onClick={this.onDeliveryHourAdderClicked} >Add</button>
  }
}

DeliveryHourEditRowAdder.propTypes = {
  row: PropTypes.shape({
    poolTimes: PropTypes.arrayOf(PropTypes.shape({
      startTime: PropTypes.string,
      endTime: PropTypes.string
    })).isRequired
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  dayName: PropTypes.string
}

DeliveryHourEditRowAdder.defaultProps = {
  dayName: ''
}



// WEBPACK FOOTER //
// ./src/containers/pools/details/deliveryHours/deliveryHourEditRowAdder.js